// socialShare.js

import "jssocials";

export function initializeSocialShare() {
  // Customize the logos before initializing jsSocials
  jsSocials.shares.email.logo = "fas fa-envelope-open";
  jsSocials.shares.linkedin.logo = "fab fa-linkedin";
  jsSocials.shares.twitter.logo = "fab fa-x-twitter";

  // Initialize jsSocials with the necessary parameters
  $("#share").jsSocials({
    shares: ["email", "linkedin", "twitter"],
    showLabel: false,
    showCount: false,
  });
}
